<template>
  <div class="card card-box mb-5">
    <div class="card-body">
      <form>
        <div class="form-row">
          <div class="form-group col-md-12">
            <b-container class="bv-example-row">
              <b-form-group>
                <b-row>
                  <div class="col-md-12 col-lg-4 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <strong><label for="kondisi">Kondisi Pasien Saat Pulang</label></strong>
                    <vue-select-clearable
                      :options="['Stabil', 'Tidak Stabil', 'Perbaikan']"
                      :value="status_pulang.status_pasien"
                      placeholder="Pilih Kondisi Pasien Saat Pulang"
                      class="custom_select"
                      id="kondisi_pasien"
                      @input="updateStatusPasien"
                    >
                    </vue-select-clearable>
                  </div>
                  <div v-if="saving_params.is_bpjs" class="col-md-12 col-lg-4 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <strong>Status Pulang <label style="color:red"> *</label></strong>
                    <vue-select-clearable
                      :options="status_pulang.options"
                      :value="status_pulang.selected"
                      placeholder="Pilih Status Pulang"
                      class="custom_select"
                      id="status_pulang"
                      @input="updateStsPulang"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.label }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.label }}
                      </template>
                    </vue-select-clearable>
                  </div>
                  <div v-if="saving_params.is_bpjs" class="col-md-12 col-lg-3 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <a v-if="showBtnRujukan()" tabindex="0" class="btn btn-primary btn_faskes" style="margin-top: 2rem;" @click="showModalRujukan">
                      <span class="btn-wrapper--label">Cari Rujukan</span>
                    </a>
                  </div>
                  <div class="col-md-12 col-lg-12 my-3 font-weight-bold" v-if="saving_params.is_bpjs && rujukan.is_tipe_rujuk && showBtnRujukan()">
                    <b-row v-if="tacc_show.faktor">
                      <b-col sm="3">Faktor Rujukan</b-col>
                      <b-col sm="9">: {{ tacc_show.faktor || '-' }}</b-col>
                    </b-row>
                    <b-row v-if="tacc_show.alasan">
                      <b-col sm="3">Alasan</b-col>
                      <b-col sm="9">: {{ tacc_show.alasan || '-' }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">PPK Rujukan</b-col>
                      <b-col sm="9">: {{ rujukan.detail.faskes || '-' }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">Spesialis/Subspesialis</b-col>
                      <b-col sm="9" v-if="rujukan.detail.spesialis && rujukan.detail.subspesialis">
                        : {{ rujukan.detail.spesialis || '-' }}{{ rujukan.detail.subspesialis ? ` / ${rujukan.detail.subspesialis}` : '' }}
                      </b-col>
                      <b-col sm="9" v-else-if="rujukan.detail.spesialis">: {{ rujukan.detail.spesialis || '-' }}</b-col>
                      <b-col sm="9" v-else-if="rujukan.detail.subspesialis">: {{ rujukan.detail.subspesialis || '-' }}</b-col>
                      <b-col sm="9" v-else>: -</b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">Catatan</b-col>
                      <b-col sm="9">: {{ rujukan.detail.catatan || '-' }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">Tgl. Rencana Berkunjung</b-col>
                      <b-col sm="9">: {{ rujukan.tanggal_rujuk ? setTglRujukan(rujukan.tanggal_rujuk) : '-' }}</b-col>
                    </b-row>
                  </div>
                </b-row>
                <b-row class="mt-3">
                  <div class="col-md-12 col-lg-4 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <strong>Konsultasi Selanjutnya</strong>
                    <vue-select @click="triggerDob" class="text-capitalize bg-white mt-2" :options="waktuKonsul" v-model="selectedRadio" @input="selectingWaktu($event)" />
                  </div>
                  <div class="col-md-12 col-lg-3 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <template v-if="selectedRadio && selectedRadio.label === 'Pilih Tanggal...' ">
                      <strong>Tanggal Konsultasi</strong>

                      <b-form-group class="mt-2">
                        <DatePickerX v-model="tanggalSelected" @input="onTanggalSelected" required
                          :popover="{ placement: 'auto', visibility: 'click', positionFixed: true }" mode="single"
                          :input-props="{placeholder: 'Pilih Tanggal', readonly: true}"
                          :input-style="
                            getDataError({ rawLabel: 'valuetglpilih' }) === null
                              ? null
                              : getDataError({ rawLabel: 'valuetglpilih' })
                              ? null
                              : 'border-color: red'
                          "
                          :is-required="true" :minDate="minimumDatetime"
                        >
                          <template v-slot="{ inputValue, inputEvents }">
                            <b-form-input
                              placeholder="Pilih Tanggal Konsultasi"
                              :value="inputValue"
                              v-on="inputEvents"
                              :readonly="true"
                              class="col-md-12 mt-2"
                              style="background-color:#ffffff;"
                            ></b-form-input>
                          </template>
                        </DatePickerX>
                        <font-awesome-icon
                          icon="calendar"
                          style="
                            float: right !important;
                            position: absolute;
                            right: 35px;
                            top: 50px;
                            color: gray;
                          "
                        />
                      </b-form-group>
                    </template>
                    <template v-if="selectedRadio && selectedRadio.label !== 'Tidak perlu konsul lanjutan' && selectedRadio.label !== 'Pilih Tanggal...' && selectedRadio.label !=='' ">
                      <strong>Tanggal Konsultasi</strong>
                      <Datetime input-class="form-control" class="d-flex input-group mt-2" zone="Asia/Jakarta"
                        value-zone="Asia/Jakarta" :value="hasil" format="d LLL yyyy" disabled>
                        <template v-slot:after>
                          <b-input-group-text
                            @click="triggerDob" slot="append"
                            style=" border-top-left-radius:0; border-left-width: 0; border-bottom-left-radius: 0; cursor: pointer"
                          >
                            <font-awesome-icon class="mx-auto " icon="calendar" />
                          </b-input-group-text>
                        </template>
                      </Datetime>
                    </template>
                  </div>

                  <template v-if="selectedRadio && selectedRadio.label !== 'Tidak perlu konsul lanjutan' && selectedRadio.label !=='' ">
                    <div class="col-lg-5 mr-0 pr-0">
                      <div class="col-lg-12">
                        <label class="text-primary ">
                          <font-awesome-icon
                            v-tooltip.bottom-start="'Pengingat akan dikirimkan kepada pasien 1 hari sebelum waktu kunjungan!'"
                            class="mx-auto" icon="info-circle" />
                          Aktifkan pengingat melalui Email?
                          <template v-if="pengingatvalue === true">
                            <vue-select class="text-capitalize bg-white mt-2 " :options="PilihanPengingat"
                              v-model="selectedPengingat" disabled="disabled" />
                            <b-input type="text" class="form-control mt-1" :state="pasienEmailError.state"
                              :placeholder="phEmailReminder" v-model="pasienEmail" @input="pasienEmailInput" />
                            <div class="invalid-feedback d-block" v-if="pasienEmailError.state == false">
                              {{ pasienEmailError.message }}</div>
                          </template>
                        </label>
                        <toggle-button v-model="pengingatvalue" :labels="{ checked: ' Ya', unchecked: ' Tidak' }"
                          :width="60" :height="20" :color="{
                            checked: '#3c44b1',
                            unchecked: '#f83245',
                            disabled: '#CCCCCC'
                          }" class="float-right" />
                      </div>
                      <div class="col-lg-12">

                        <div class="text-primary ">
                          <font-awesome-icon
                            v-tooltip.bottom-start="'Dapat digunakan apabila Anda telah melakukan Pembelian Add-On Patient Engagement WA/SMS!'"
                            class="mx-auto" icon="info-circle" />
                          Aktifkan pengingat melalui SMS/WA
                          <toggle-button v-model="pengingatWAvalue" :labels="{ checked: ' Ya', unchecked: ' Tidak' }"
                            :width="60" :height="20" :disabled="addons && addons[0].sisa == 0 && addons[1].sisa == 0"
                            :color="{
                            checked: '#3c44b1',
                            unchecked: '#f83245',
                            disabled: '#CCCCCC'
                          }" class="float-right" />
                          <template v-if="pengingatWAvalue === true">
                            <b-form-select v-model="selectedPengingatWA" @input="selectedReminder"
                              class="mt-2 form-control col-md-10 mb-2 select-red">
                              <template #first>
                                <b-form-select-option :value="null" disabled>Pilih Reminder</b-form-select-option>
                                <b-form-select-option value="whatsapp" v-if="addons && addons[1].sisa !== 0">Whatsapp
                                  <label> ({{addons[1].sisa}} kuota pesan tersisa!) </label>
                                </b-form-select-option>
                                <b-form-select-option value="sms" v-if="addons && addons[0].sisa !== 0">SMS
                                  <label>({{addons[0].sisa}} kuota
                                    pesan tersisa!)</label></b-form-select-option>
                              </template>
                            </b-form-select>
                            <br>
                            <span style="margin-bottom:8px !important">No. Handphone</span>
                            <b-input type="text" class="form-control mt-2 col-md-10" :state="pasienNomorError.state"
                              placeholder="Tuliskan No. Handphone" maxlength="15"
                              onkeyup="this.value=this.value.replace(/[^\d]/,'')" v-model="pasienNomor"
                              @input="pasienNomorInput" />
                            <div class="invalid-feedback d-block" v-if="pasienNomorError.state == false">
                              {{ pasienNomorError.message }}</div>
                          </template>
                        </div>
                        <br>
                      </div>
                    </div>
                  </template>
                </b-row>
              </b-form-group>
            </b-container>
          </div>
        </div>
      </form>
    </div>
    
    <!-- modal rujukan -->
    <b-modal
      ref="__modal_rujukan"
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_rujukan"
      title="Pencarian Fasilitas Kesehatan Rujukan"
      size="xl"
    >
      <div class="accordion">
        <div class="card card-rujukan">
          <div class="card-header">
            <div
              class="custom-control custom-radio"
              :style="rujukan.selected == 'horizontal' ? 'border-bottom: 5px solid #3c44b1;' : ''"
            >
              <input
                @input="setSelectedRujukan"
                :value="rujukan.selected"
                type="radio" id="horizontal"
                name="rujukan" class="custom-control-input"
                v-b-toggle.horizontal
                :checked="rujukan.selected == 'horizontal'"
                :disabled="true"
              />
              <label class="custom-control-label" for="horizontal">Rujukan Horizontal</label>
            </div>
          </div>
          <b-collapse id="horizontal" accordion="accordion" role="tabpanel">
            <div class="card-body">
              <h4 class="pl-3">* Rujukan Horizontal</h4>
            </div>
          </b-collapse>
        </div>
        <div class="card card-rujukan">
          <div class="card-header">
            <div
              class="custom-control custom-radio"
              :style="rujukan.selected == 'vertical' ? 'border-bottom: 5px solid #3c44b1;' : ''"
            >
              <input
                @input="setSelectedRujukan"
                :value="rujukan.selected"
                type="radio" id="vertical" name="rujukan"
                class="custom-control-input"
                v-b-toggle.vertical
                :checked="rujukan.selected == 'vertical'"
              />
              <label class="custom-control-label" for="vertical">Rujukan Vertikal</label>
            </div>
          </div>
          <b-collapse id="vertical" accordion="accordion" role="tabpanel">
            <div class="card-body pt-0">
              <div class="accordion accordion_vertical">
                <div class="card card-rujukan">
                  <div class="card-header">
                    <div class="custom-control custom-radio">
                      <input
                        @input="setSelectedVertical"
                        :value="rujukan.selectedVertical"
                        type="radio" id="khusus" name="rujukan_vertical"
                        class="custom-control-input"
                        v-b-toggle.khusus
                        :checked="rujukan.selectedVertical == 'khusus'"
                      />
                      <label class="custom-control-label" for="khusus">Kondisi Khusus</label>
                    </div>
                  </div>
                  <b-collapse id="khusus" accordion="accordion_vertical" role="tabpanel">
                    <div class="card-body row px-5 py-0">
                      <div class="col-md-8 py-2" style="border: 1px solid #d1d2db;">
                        <b-row class="my-1">
                          <b-col sm="3">
                            <label for="input-none">Kategori</label>
                          </b-col>
                          <b-col sm="9">
                            <vue-select-clearable
                              :options="rujukan.khusus.optKhusus"
                              v-model="rujukan.khusus.selectedKhusus"
                              placeholder="Pilih Kategori"
                              :class="rujukan.khusus.show_subspesialis ? 'custom_select kategori_khusus_subspesialis' : 'custom_select kategori_khusus'"
                              id="kategori"
                            >
                            </vue-select-clearable>
                            <span v-if="rujukan.error.reffKhusus" style="color:red;font-size:12px">
                              Wajib diisi
                            </span>
                          </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="rujukan.khusus.show_subspesialis">
                          <b-col sm="3">
                            <label for="input-none">Spesialis</label>
                          </b-col>
                          <b-col sm="9">
                            <vue-select-clearable
                              :options="rujukan.khusus.optSubSpesialis"
                              v-model="rujukan.khusus.selectedSubSpesialis"
                              placeholder="Pilih Spesialis"
                              class="custom_select kategori_khusus"
                              id="spesialis"
                            >
                            </vue-select-clearable>
                            <span v-if="rujukan.error.reffKhususSubSpesialis" style="color:red;font-size:12px">
                              Wajib diisi
                            </span>
                          </b-col>
                        </b-row>
                        <b-row class="my-1">
                          <b-col sm="3">
                            <label for="input-none">Alasan</label>
                          </b-col>
                          <b-col sm="9">
                            <b-form-textarea v-model="rujukan.khusus.note_khusus" @input="checkAlasan()"></b-form-textarea>
                            <span v-if="rujukan.error.note_khusus" style="color:red;font-size:12px">
                              {{ rujukan.error.note_khusus_msg }}
                            </span>
                          </b-col>
                        </b-row>
                      </div> 
                    </div>
                  </b-collapse>
                </div>
                <div class="card card-rujukan">
                  <div class="card-header">
                    <div class="custom-control custom-radio">
                      <input
                        @input="setSelectedVertical"
                        :value="rujukan.selectedVertical"
                        type="radio" id="spesialis"
                        name="rujukan_vertical" class="custom-control-input"
                        v-b-toggle.spesialis
                        :checked="rujukan.selectedVertical == 'spesialis'"
                      />
                      <label class="custom-control-label" for="spesialis">Spesialis</label>
                    </div>
                  </div>
                  <b-collapse id="spesialis" accordion="accordion_vertical" role="tabpanel">
                    <div class="card-body row px-5 pt-0 pb-5">
                      <div class="col-md-12 py-2">
                        <b-row class="my-1">
                          <b-col sm="2">
                            <label for="input-none">Spesialis</label>
                          </b-col>
                          <b-col sm="4" class="px-0">
                            <vue-select-clearable
                              :options="rujukan.spesialis.optSpesialis"
                              v-model="rujukan.spesialis.selectedSpesialis"
                              placeholder="Pilih Spesialis"
                              class="custom_select spesialis_subspesialis"
                              id="spesialis1"
                            >
                            </vue-select-clearable>
                            <span v-if="rujukan.error.reffSpesialis" style="color:red;font-size:12px">
                              Wajib diisi
                            </span>
                          </b-col>
                          <b-col sm="4" class="pr-0">
                            <vue-select-clearable
                              :options="rujukan.spesialis.optSubSpesialis"
                              v-model="rujukan.spesialis.selectedSubSpesialis"
                              class="custom_select spesialis_subspesialis"
                              id="spesialis2"
                            >
                            </vue-select-clearable>
                            <span v-if="rujukan.error.reffSubSpesialis" style="color:red;font-size:12px">
                              Wajib diisi
                            </span>
                          </b-col>
                        </b-row>
                        <b-row class="my-1">
                          <b-col sm="2">
                            <label for="input-none">
                              <b-form-checkbox
                                id="checkbox-1"
                                name="checkbox-1"
                                value="accepted"
                                unchecked-value="not_accepted"
                                v-model="rujukan.spesialis.checkboxSarana"
                              >
                                Sarana
                              </b-form-checkbox>
                            </label>
                          </b-col>
                          <b-col sm="4" class="px-0" v-if="rujukan.spesialis.show_sarana">
                            <vue-select-clearable
                              :options="rujukan.spesialis.optSarana"
                              v-model="rujukan.spesialis.selectedSarana"
                              placeholder="Pilih Sarana"
                              class="custom_select kategori_khusus"
                              id="sarana"
                            >
                            </vue-select-clearable>
                            <span v-if="rujukan.error.reffSarana" style="color:red;font-size:12px">
                              Wajib diisi
                            </span>
                          </b-col>
                        </b-row>
                      </div> 
                    </div>
                  </b-collapse>
                </div>
                <span v-if="rujukan.error.vertical" style="color:red;font-size:12px;padding-left:20px;">
                  Silakan pilih salah satu
                </span>
              </div>
              
              <b-row class="px-3">
                <b-col sm="3" class="px-0 pt-3" style="border-top: 2px solid rgb(209, 210, 219);">
                  <label for="input-none">
                    <b>Tanggal Rencana Berkunjung</b>
                  </label>
                </b-col>
                <b-col sm="5" style="border-top: 2px solid rgb(209, 210, 219);">
                  <b-form-group>
                    <DatePickerX v-model="rujukan.tanggal_rujuk"
                      :popover="{ placement: 'auto', visibility: 'click', positionFixed: true }" mode="single"
                      :input-props="{placeholder: 'Pilih Tanggal', readonly: true}"
                      :input-style="
                        getDataError({ rawLabel: 'valuetglpilih' }) === null
                          ? null
                          : getDataError({ rawLabel: 'valuetglpilih' })
                          ? null
                          : 'border-color: red'
                      "
                      :is-required="true" :minDate="minTglRujuk"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <b-form-input
                          placeholder="Pilih Tanggal Rujukan"
                          :value="inputValue"
                          v-on="inputEvents"
                          :readonly="true"
                          class="col-md-12 mt-2"
                          style="background-color:#ffffff;"
                        ></b-form-input>
                      </template>
                    </DatePickerX>
                    <font-awesome-icon
                      icon="calendar"
                      style="
                        float: right !important;
                        position: absolute;
                        right: 35px;
                        top: 20px;
                        color: gray;
                      "
                    />
                    <span v-if="rujukan.error.tanggal_rujuk" style="color:red;font-size:12px">
                      Wajib diisi
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="4" class="offset-4">
                  <a tabindex="0" class="btn btn-primary btn_faskes" @click="fetchFaskesRujukan">
                    <span class="btn-wrapper--label">Cari Faskes Rujukan</span>
                  </a>
                  <a tabindex="0" class="btn btn-danger ml-3 btn_faskes" @click="hideModalRujukan">
                    <span class="btn-wrapper--label">Batal</span>
                  </a>
                </b-col>
              </b-row>

              <b-row class="pt-4 row-rounded" style="margin-bottom: -20px;">
                <b-col md="3" class="my-1 page-select">
                  <b-form-group
                    label="Show"
                    label-for="per-page-select"
                    label-cols-lg="3"
                    label-align-sm="right"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="table.perPage"
                      :options="table.pageOptions"
                      size="sm"
                      style="max-width:75px;"
                    ></b-form-select>
                    <label for="entries" class="pl-1">Entries</label>
                  </b-form-group>
                </b-col>
                <b-col md="4" class="text-right offset-5">
                  <b-form-group
                    label="Cari"
                    label-cols-lg="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-class="d-flex align-items-center justify-content-end"
                    class="mb-0"
                  >
                    <b-input id="filter-input" v-model="table.keyword" type="search"></b-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <div class="table-responsive mt-4">
                    <b-table
                      :fixed="true"
                      :items="table.listFaskes"
                      :fields="fieldFaskes"
                      :filter="table.keyword"
                      :borderless="true"
                      :current-page="table.currentPage"
                      :per-page="table.perPage"
                      class="table_faskes"
                    >
                      <!-- slot head -->
                      <template v-slot:head()="data">
                        <div class="text-center">
                          {{ data.label }}
                        </div>
                      </template>

                      <!-- slot cell -->
                      <template v-slot:cell(total_rujukan)="data">
                        <p class="text-center">
                          {{ data.item.total_rujukan }}
                        </p>
                      </template>
                      <template v-slot:cell(kapasitas)="data">
                        <p class="text-center">
                          {{ data.item.kapasitas }}
                        </p>
                      </template>
                      <template v-slot:cell(percentage)="data">
                        <p class="text-center">
                          {{ data.item.percentage }}
                        </p>
                      </template>
                      <template v-slot:cell(pilih)="data">
                        <b-button variant="secondary" @click="setSelectedFaskes(data.item)">Pilih</b-button>
                      </template>
                    </b-table>
                  </div>

                  <div class="d-flex align-items-center justify-content-center">
                    <span class="pl-2">
                      Display {{ table.fromX }} to {{ table.toX }} of {{ table.totalEntries }} entries
                    </span>
                    <b-pagination
                      class="mt-4 d-flex justify-content-center flex-grow-1"
                      v-model="table.currentPage"
                      :total-rows="table.totalEntries"
                      :per-page="table.perPage"
                      style="margin-left: -10em"
                    ></b-pagination>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </div>
      </div>
    </b-modal>

    <!-- modal rujukan confirm -->
    <b-modal
      ref="__modal_rujukan_confirm"
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_rujukan"
      size="xl"
    >
      <b-row>
        <b-col sm="12">
          <span>
            Dengan ini saya menyatakan merujuk pasien berdasarkan diagnosis kerja saat ini bahwa pasien memerlukan pemeriksaan lanjutan dengan kondisi data yang benar sesuai indikasi medis tanpa adanya indikasi penyalahgunaan.
          </span>
        </b-col>
        <b-col sm="12" class="text-right">
            <a tabindex="0" class="btn btn-primary btn_faskes" @click="showModalConfirm">
              <span class="btn-wrapper--label">Ya</span>
            </a>
            <a tabindex="0" class="btn btn-danger ml-3 btn_faskes" @click="hideModalConfirm">
              <span class="btn-wrapper--label">Tidak</span>
            </a>
        </b-col>
      </b-row>
    </b-modal>

    <!-- modal rujukan print -->
    <b-modal
      ref="__modal_rujukan_print"
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_rujukan"
      title="Cetak Rujukan"
      size="xl"
    >
      <b-row>
        <b-col sm="12">
          <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
            <b-form-radio v-model="rujukan.tipe_rujuk" :aria-describedby="ariaDescribedby" name="some-radios" value="rujuk">
              Surat Rujukan Lanjut
            </b-form-radio>
            <b-form-radio v-model="rujukan.tipe_rujuk" :aria-describedby="ariaDescribedby" name="some-radios" value="rujuk_balik">
              Surat Rujukan Lanjut + Rujuk Balik
            </b-form-radio>
          </b-form-group>
          <span v-if="rujukan.error.tipe_rujuk" style="color:red;font-size:12px">
            Silakan pilih salah satu
          </span>
        </b-col>
        <b-col sm="12" class="text-right">
            <a tabindex="0" class="btn btn-primary btn_faskes" @click="showPrint">
              <span class="btn-wrapper--label">Setuju</span>
            </a>
            <a tabindex="0" class="btn btn-danger ml-3 btn_faskes" @click="hideModalPrint">
              <span class="btn-wrapper--label">Batal</span>
            </a>
        </b-col>
      </b-row>
    </b-modal>
    
    <!-- modal tacc -->
    <b-modal
      ref="__modal_tacc"
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_rujukan"
      title="Konfirmasi Rujukan TACC"
      size="lg"
    >
      <div class="accordion">
        <div class="card card-rujukan">
          <div class="card-header">
            <p>Diagnosa yang dipilih merupakan diagnosa non spesialistik, apakah pasien tersebut akan tetap di rujuk?</p>
            <div class="custom-control custom-radio">
              <input
                @input="setSelectedTACC"
                :value="tacc.selected"
                type="radio" id="dengan_tacc"
                name="tacc" class="custom-control-input"
                v-b-toggle.dengan_tacc
                :checked="tacc.selected == 'dengan_tacc'"
              />
              <label class="custom-control-label" for="dengan_tacc">Rujuk dengan TACC</label>
            </div>
            <div class="custom-control custom-radio mt-3">
              <input
                @input="setSelectedTACC"
                :value="tacc.selected"
                type="radio" id="tanpa_tacc"
                name="tacc" class="custom-control-input"
                v-b-toggle.tanpa_tacc
                :checked="tacc.selected == 'tanpa_tacc'"
              />
              <label class="custom-control-label" for="tanpa_tacc">Rujuk tanpa TACC</label>
            </div>
          </div>

          <div class="card-body">
            <b-collapse id="tanpa_tacc" accordion="accordion" role="tabpanel">&nbsp;</b-collapse>

            <b-collapse id="dengan_tacc" accordion="accordion" role="tabpanel">
              <b-row>
                <b-col sm="6">
                  <b-form-group class="text-capitalize" style="position: relative">
                    <label>Faktor Rujukan<span class="text-danger">*</span>:</label>
                    <br />
                    <template>
                      <vue-select-clearable
                        id="faktor_rujukan"
                        :class="{'error': tacc.error_faktor}"
                        :options="tacc.option_faktor"
                        v-model="tacc.faktor"
                        placeholder="Pilih Faktor Rujukan"
                        class="__form-tacc mt-2"
                        @input="setTaccValue($event, 'kd_tacc')"
                      >
                      </vue-select-clearable>
                      <b-form-invalid-feedback class="text-lowercase" :state="!tacc.error_faktor">
                        wajib diisi
                      </b-form-invalid-feedback>
                    </template>
                  </b-form-group>
                </b-col>
                <b-col sm="6" v-if="tacc.faktor && tacc.faktor.value != '3'">
                  <b-form-group class="text-capitalize" style="position: relative">
                    <label>Alasan<span class="text-danger">*</span>:</label>
                    <br />
                    <template>                  
                      <vue-select-clearable
                        id="alasan_rujukan"
                        :class="{'error': tacc.error_alasan}"
                        :options="tacc.option_alasan"
                        v-model="tacc.alasan"
                        placeholder="Pilih Alasan"
                        class="__form-tacc mt-2"
                        @input="setTaccValue($event, 'alasan_tacc')"
                      >
                      </vue-select-clearable>
                      <b-form-invalid-feedback class="text-lowercase" :state="!tacc.error_alasan">
                        wajib diisi
                      </b-form-invalid-feedback>
                    </template>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>
          </div>
        </div>
      </div>
      <b-row>
        <b-col sm="12" class="text-right">
          <a tabindex="0" class="btn btn-tacc-agree btn_faskes" @click="showModalTACC()">
            <span class="btn-wrapper--label">Setuju</span>
          </a>
          <a tabindex="0" class="btn btn-dark ml-3 btn_faskes" @click="hideModalTACC()">
            <span class="btn-wrapper--label">Batal</span>
          </a>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters
  } from "vuex";
  import "vue-datetime/dist/vue-datetime.css";
  import { Datetime } from "vue-datetime";
  import moment from "moment";
  import { library } from "@fortawesome/fontawesome-svg-core";
  import { faCalendar, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
  import { ToggleButton } from 'vue-js-toggle-button';
  import rekamMedisMixin from "../mixins";
  
  library.add(faCalendar, faInfoCircle);
  export default {
    mixins: [rekamMedisMixin],
    components: {
      "toggle-button": ToggleButton,
      Datetime,
      "vue-select": () => import("@/components/VueSelect.vue"),
      DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
      "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
    },
    data() {
      return {
        slider: {
          status: true
        },
        phEmailReminder: "Inputkan Email...",
        selectedRadio: {
          label: 'Tidak perlu konsul lanjutan',
          value: 99
        },
        selectedPengingat: {},
        selectedPengingatWA: null,
        pilihRemember: null,
        PilihanPengingat: [{
          label: 'Email',
          value: 1
        }, ],
        waktuKonsul: [{
            label: 'Tidak perlu konsul lanjutan',
            value: 99
          },
          {
            label: '1 minggu',
            value: 7
          },
          {
            label: '2 minggu',
            value: 14
          },
          {
            label: '1 bulan',
            value: 30
          },
          {
            label: 'Pilih Tanggal...',
            value: 1
          }
        ],
        hari: 0,
        valuetglpilih: "",
        tglpilih: "",
        pengingatvalue: false,
        pengingatWAvalue: false,
        test: null,
        checkbox: true,
        pasienEmail: null,
        pasienNomor: null,
        pasienEmailError: {
          state: null,
          message: ""
        },
        pasienNomorError: {
          state: null,
          message: ""
        },
        addons: null,
        profile: null,
        ediRekamMedis: {},
        editRujukan: {},
        tanggalSelected: null,
        isEditRM: false,
        bpjs_noka: null,
        rujukan: this.defaultRujukan(),
        table: this.defaultTable(),
        tacc: this.defaultTACC(),
        tacc_show: {
          faktor: null,
          alasan: null,
        },
      };
    },
    computed: {
      ...mapGetters([
        "pasien",
        "getKlinikId",
        "status_pulang",
        "saving_params",
        "postData",
        "error_sync_msg"
      ]),
      minimumDatetime() {
        let minDate = moment().add(1, "days").toDate();
        if (this.tanggalSelected && this.tanggalSelected < minDate && this.isEditRM && this.hari == 1) {
          minDate = this.tanggalSelected;
        }
        return minDate;
      },
      minTglRujuk() {
        return moment().toDate();
      },
      hasil() {
        return moment().add(this.hari, 'days').format("YYYY-MM-DD");
      },
      fieldFaskes() {
        return [
          {
            key: "no",
            label: "NO",
            thClass: "py-3 head_custom",
            stickyColumn: true,
            isRowHeader: true
          },
          {
            key: "faskes",
            label: "FASKES",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "kelas",
            label: "KELAS",
            thClass: "py-3 head_custom",
          },
          {
            key: "kantor_cabang",
            label: "KANTOR CABANG",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "alamat",
            label: "ALAMAT",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "telp",
            label: "TELP",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "jarak",
            label: "JARAK",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "total_rujukan",
            label: "TOTAL RUJUKAN",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "kapasitas",
            label: "KAPASITAS",
            thClass: "py-3 head_custom",
          },
          {
            key: "percentage",
            label: "(%)",
            thClass: "py-3 head_custom",
          },
          {
            key: "jadwal",
            label: "JADWAL",
            thClass: "py-3 head_custom head_width",
          },
          {
            key: "pilih",
            label: "PILIH",
            thClass: "py-3 head_custom",
            thStyle: "min-width: 100px;",
          },
        ];
      },
    },
    async created() {
      this.ediRekamMedis = localStorage.getItem("edit_rekam_medis");
      this.selectedPengingat = {
        label: 'Email',
        value: 1
      };
      this.updateSavingParams({
        key: 'is_next_konsul',
        value: true
      });
      this.getProfile();
      if (this.ediRekamMedis) {
        this.updateSavingParams({
          key: 'is_email_format',
          value: true
        });
        this.updateSavingParams({
          key: 'is_email',
          value: true
        });
        this.updateSavingParams({
          key: 'is_number',
          value: true
        });
        this.updateSavingParams({
          key: 'is_reminder',
          value: true
        });

        this.selectedStatus = this.status_pulang.selected
        let rm = JSON.parse(this.ediRekamMedis)

        if (this.saving_params.is_bpjs || rm.transklinik.kategori_id == 2) {
          this.editRujukan = localStorage.getItem("edit_rujukan");
          if (this.editRujukan) {
            const editRujuk = JSON.parse(this.editRujukan);
            const tglEstRujuk = editRujuk.tglRencanaBerkunjung ? moment(editRujuk.tglRencanaBerkunjung.split('-').reverse().join('-')).toDate() : null;
            let catatan = editRujuk.catatan;
            if (catatan && catatan.split(', ').length > 1) {
              catatan = catatan.split(', ')[1] || null;
            }
            let spesialis = null;
            let subSpesialis = null;
            if (editRujuk.ref_khusus) {
              spesialis = editRujuk.ref_khusus.nmKhusus || null;
              if (editRujuk.subSpesialis_khusus) {
                subSpesialis = editRujuk.subSpesialis_khusus.nmSubSpesialis || null;
              }
            }
            if (editRujuk.subSpesialis_spesialis) {
              subSpesialis = editRujuk.subSpesialis_spesialis.nmSubSpesialis || null;
            }
            this.rujukan = {
              ...this.defaultRujukan(),
              tanggal_rujuk: tglEstRujuk,
              is_tipe_rujuk: true,
              detail: {
                faskes: editRujuk.ppkRujukan,
                spesialis: spesialis,
                subspesialis: subSpesialis,
                catatan: catatan,
              },
            }

            if (this.tacc.option_faktor.length < 1) this.tacc.option_faktor = await this.fetchFaktorRujukan(this.getKlinikId);
            if (rm.bpjs_health_data && rm.bpjs_health_data.kd_tacc) {
                const faktor = this.tacc.option_faktor.find(f => f.value == rm.bpjs_health_data.kd_tacc);
                if (faktor) {
                  this.tacc_show.faktor = faktor.label || null;
                  this.tacc_show.alasan = rm.bpjs_health_data.alasan_tacc || null;
                }
            }
          }
        }

        if (rm.transklinik.next_konsultasi != "99") {
          this.isEditRM = true
          if (rm.transklinik.next_konsultasi == '1') {
            this.tanggalSelected = rm.transklinik.tgl_next_konsultasi != '1970-01-01' ? moment(rm.transklinik.tgl_next_konsultasi).toDate() : null
          } else {
            this.tanggalSelected = moment().add(1, 'days').toDate()
          }
          this.hari = rm.transklinik.next_konsultasi

          // email reminder
          if (rm.pasien.email_reminder == 1) {
            this.pengingatvalue = this.isEditRM = true
            this.pasienEmail = rm.pasien.email
          }
          // add on
          const rm_addon = rm.patient_engagement[0] || null
          if (rm_addon) {
            this.pengingatWAvalue = true
            this.selectedPengingatWA = rm_addon.tipe_addson || null
            this.pasienNomor = rm_addon.nomor_hp_pasien;
            this.validateNomor(this.pasienNomor);
          }
        }

        if(rm.transklinik.next_konsultasi == "7") {
          this.selectedRadio = {
            label: '1 minggu',
            value: 7
          }
        } else if(rm.transklinik.next_konsultasi == "14") {
          this.selectedRadio = {
            label: '2 minggu',
            value: 14
          }
        } else if(rm.transklinik.next_konsultasi == "30") {
          this.selectedRadio = {
            label: '1 bulan',
            value: 30
          }
        } else if(rm.transklinik.next_konsultasi == "1") {
          this.selectedRadio = {
            label: 'Pilih Tanggal...',
            value: 1
          }
        }
      } else {
        this.updatePostData({
          key: 'next_konsultasi',
          value: 99
        });
        this.updatePostData({
          key: 'tgl_next_konsultasi',
          value: false
        });
      }
    },
    methods: {
      ...mapActions([
        "updatePostData",
        "updateSavingParams",
        "updateStatusPulang",
        "saveRekamMedis"
      ]),
      customFormatter(date) {
        return moment(date).format('dd MMM yyyy');

      },
      onTanggalSelected($event) {
        if ($event) {
          this.tgl_next_konsultasi = $event
          this.updatePostData({
            key: 'tgl_next_konsultasi',
            value: this.tgl_next_konsultasi
          });

          this.updatePostData({
            key: 'next_konsultasi',
            value: '1'
          });

          this.updateSavingParams({
            key: 'is_next_konsul',
            value: true
          });
        } else {
          this.updateSavingParams({
            key: 'is_next_konsul',
            value: false
          });
          this.updatePostData({
            key: 'tgl_next_konsultasi',
            value: false
          });
          this.updatePostData({
            key: 'next_konsultasi',
            value: 99
          });

        }
      },
      handleError(message) {
        return this.$swal({
          type: "error",
          title: "Oops...",
          html: message
        });
      },
      triggerDob() {
        const x = this.$refs.dob
        const {
          $el: {
            firstElementChild
          }
        } = x
        firstElementChild && firstElementChild.click()
      },
      selectingWaktu($event) {
        this.hari = $event.value
        
        if(this.hari != 99){
          this.pengingatvalue = true;
          this.updatePostData({
            key: 'next_konsultasi',
            value: this.hari
          });
        }

        if (this.hari !== 1) {
          if (this.hari == 99) {
            this.hari = 0;
            this.updatePostData({
              key: 'tgl_next_konsultasi',
              value: false
            });
          } else {
            this.tgl_next_konsultasi = this.hasil;
            this.updatePostData({
              key: 'tgl_next_konsultasi',
              value: this.hasil
            });
          }
        } else {
          this.updatePostData({
            key: 'tgl_next_konsultasi',
            value: false
          });
        }
      },
      async getProfile() {
        try {
          var checkRole = this.$store.state.user.id;

          const res = await this.$axios.get(`user/${checkRole}?klinik_id=${this.getKlinikId}`);
          const pasien_id = this.$router.currentRoute.params.pasien_id;
          let withParentQS = null;
          if (localStorage.getItem('with_parent') == 1){
            withParentQS = '&with_parent=1';
          }
          const resPasien = await this.$axios.get(`pasien/${pasien_id}?klinik_id=${this.getKlinikId}&id=${pasien_id}${withParentQS}`);
          const { status, data } = resPasien.data;

          if (status) {
            this.pasienEmail = data.email;
            this.bpjs_noka = data.bpjs_noka;
          }

          this.addons = res.data.addons;
          if (this.ediRekamMedis != null) {
            let rm = JSON.parse(this.ediRekamMedis)
            const rm_addon = rm.patient_engagement[0] || null
            if (rm_addon) {
              this.pasienNomor = rm_addon.nomor_hp_pasien || resPasien.data.data.nomor_hp;
            }else{
              this.pasienNomor = resPasien.data.data.nomor_hp;
            }
          } else {
            this.pasienNomor = resPasien.data.data.nomor_hp;
          }
          this.validateNomor(this.pasienNomor);

          if (this.selectedRadio) {
            if (this.selectedRadio.value == 99) {
              this.updatePostData({
                key: 'pesan_konsultasi',
                value: null
              });

              this.updateSavingParams({
                key: 'is_number',
                value: true
              });

              this.updateSavingParams({
                key: 'is_reminder',
                value: true
              });

              this.updateSavingParams({
                key: 'is_next_konsul',
                value: true
              });
            }
          }
        } catch (error) {
        }
      },
      selectedReminder($event) {
        this.updateSavingParams({
          key: 'is_reminder',
          value: true
        });

        this.updatePostData({
          key: 'tipe_pesan',
          value: $event
        });
      },
      pasienEmailInput($event) {
        this.validateEmail($event);
        this.updatePostData({
          key: 'email_konsultasi',
          value: $event
        });
      },
      pasienNomorInput($event) {
        this.validateNomor($event);

        this.updatePostData({
          key: 'pesan_konsultasi',
          value: $event
        });
      },
      validateNomor(nomor) {
        //Apabila sudah membeli Add-On, toggle secara default akan menjadi aktif
        //Apabila belum membeli Add-On, maka tampilan akan sebagai berikut
        if ((nomor === '' || nomor === null || nomor === undefined) && this.pengingatWAvalue == true) {
          this.pasienNomorError.state = false;
          this.pasienNomorError.message = 'No. Handphone wajib diisi!';
          this.updateSavingParams({
            key: 'is_number',
            value: false
          });
        } else if ((nomor !== '' || nomor !== null || nomor !== undefined) && this.pengingatWAvalue == false) {
          this.pasienNomorError.state = null;
          this.pasienNomorError.message = '';
          this.updateSavingParams({
            key: 'is_number',
            value: true
          });
        } else {
          this.pasienNomorError.state = null;
          this.pasienNomorError.message = '';
          this.updateSavingParams({
            key: 'is_number',
            value: true
          });
        }
      },
      validateEmail(email) {
        if (email == '' || email == null || email == undefined && this.pengingatvalue === true) {
          this.pasienEmailError.state = false;
          this.pasienEmailError.message = 'Email Tidak Boleh Kosong';
          this.updateSavingParams({
            key: 'is_email',
            value: false
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: false
          });
        } else if (email == '' || email == null || email == undefined && this.pengingatvalue === false) {
          this.updateSavingParams({
            key: 'is_email',
            value: true
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: true
          });
        } else if (email, /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
          this.pasienEmailError.state = null;
          this.pasienEmailError.message = '';

          this.updateSavingParams({
            key: 'is_email',
            value: true
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: true
          });
        } else {
          this.pasienEmailError.state = false;
          this.pasienEmailError.message = 'Format Email Tidak Sesuai';

          this.updateSavingParams({
            key: 'is_email',
            value: false
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: false
          });
        }
      },
      updateStsPulang(event) {
        this.updateStatusPulang({ key: "selected", value: event });

        let value = null;
        if (event && typeof event == 'object') {
          value = event.value;
          
          if (value != 'Rujukan') {
            this.updatePostData({ key: 'kd_tacc', value: null });
            this.updatePostData({ key: 'alasan_tacc', value: null });
          }
        }
        this.updatePostData({ key: "kdStatusPulang", value: value });
      },
      updateStatusPasien(event) {
        this.updateStatusPulang({key: 'status_pasien', value: event})
        this.updatePostData({ key: "status_pasien", value: event })
      },
      setSelectedRujukan(event) {
        this.rujukan.selected = event.target.id;
      },
      setSelectedVertical(event) {
        this.rujukan.selectedVertical = event.target.id;
        if (this.rujukan.selectedVertical) {
          this.rujukan.error.vertical = false;
          this.table = this.defaultTable();
          if (this.rujukan.selectedVertical == 'khusus') {
            this.rujukan.spesialis = {
              ...this.rujukan.spesialis,
              selectedSpesialis: null,
              selectedSubSpesialis: null,
              selectedSarana: null,
              checkboxSarana: null,
              show_sarana: false,
            }
            this.rujukan.error = {
              ...this.rujukan.error,
              reffSpesialis: false,
              reffSubSpesialis: false,
              reffSarana: false,
              tanggal_rujuk: false,
            }
          }
          if (this.rujukan.selectedVertical == 'spesialis') {
            this.rujukan.khusus = {
              ...this.rujukan.khusus,
              selectedKhusus: null,
              selectedSubSpesialis: null,
              show_subspesialis: false,
              note_khusus: null,
            }
            this.rujukan.error = {
              ...this.rujukan.error,
              reffKhusus: false,
              reffKhususSubSpesialis: false,
              note_khusus: false,
              tanggal_rujuk: false,
            }
          }
        } else {
          this.rujukan.error.vertical = true;
        }
      },
      async fetchReff() {
        const resSpesialis = await this.$axios.get(`bpjs/referensi-spesialis?klinik_id=${this.getKlinikId}`);
        const resKhusus = await this.$axios.get(`bpjs/referensi-khusus?klinik_id=${this.getKlinikId}`);
        const resKhususSubSpesialis = await this.$axios.get(`bpjs/subspesialis-thahem`);
        const resSarana = await this.$axios.get(`bpjs/referensi-sarana?klinik_id=${this.getKlinikId}`);

        const khusus = resKhusus.data;
        if (khusus) {
          if (khusus.response.list.length > 0) {
            this.rujukan.khusus.optKhusus = khusus.response.list.map((item) => ({
              label: item.nmKhusus,
              value: item.kdKhusus,
            }));
          }
        }

        const khususSubSpesialis = resKhususSubSpesialis.data;
        if (khususSubSpesialis) {
          if (khususSubSpesialis.response.list.length > 0) {
            this.rujukan.khusus.optSubSpesialis = khususSubSpesialis.response.list.map((item) => ({
              value: item.kdSubSpesialis,
              label: item.nmSubSpesialis,
            }));
          }
        }

        const spesialis = resSpesialis.data;
        if (spesialis) {
          if (spesialis.response.list.length > 0) {
            this.rujukan.spesialis.optSpesialis = spesialis.response.list.map((item) => ({
              label: item.nmSpesialis,
              value: item.kdSpesialis,
            }));
          }
        }

        const sarana = resSarana.data;
        if (resSarana) {
          if (sarana.response.list.length > 0) {
            this.rujukan.spesialis.optSarana = sarana.response.list.map((item) => ({
              label: item.nmSarana,
              value: item.kdSarana,
            }));
          }
        }
      },
      async fetchReffSubSpesialis(kdSpesialis) {
        const res = await this.$axios.get(`bpjs/referensi-sub-spesialis?klinik_id=${this.getKlinikId}&kdSpesialis=${kdSpesialis}`);
        const { metaData, response } = res.data;

        if (metaData.code == 200) {
          this.rujukan.spesialis.optSubSpesialis = response.list.map((item) => ({
            label: item.nmSubSpesialis,
            value: item.kdSubSpesialis,
          }));
        }
      },
      async fetchFaskesRujukan() {
        this.table = this.defaultTable();
        const { selectedVertical } = this.rujukan;

        if (!selectedVertical) {
          this.rujukan.error.vertical = true;
          return;
        } else {
          this.rujukan.error.vertical = false;
        }

        if (selectedVertical == 'khusus') {
          await this.fetchFaskesKhusus();
        }

        if (selectedVertical == 'spesialis') {
          await this.fetchFaskesSpesialis();
        }
      },
      setSelectedFaskes(data) {
        this.rujukan.is_back = true;
        this.rujukan.selectedFaskes = data;
        this.$refs["__modal_rujukan"].hide();
        this.$refs["__modal_rujukan_confirm"].show();
        this.rujukan.detail.faskes = data.faskes;
        this.updatePostData({
          key: 'kdppk',
          value: data.kdppk || null,
        });
      },
      showBtnRujukan() {
        const status_pulang = this.status_pulang.selected ? this.status_pulang.selected.label : null;
        if (['Rujukan'].includes(status_pulang)) {
          return true;
        } else {
          return false;
        }
      },
      async showModalRujukan() {
        if (this.status_pulang.selected && this.status_pulang.selected.label == 'Rujukan') {
          let ns = false;
          this.$emit('icdxRujukanCheck', true);
          if (this.saving_params.is_poli_gigi && this.postData.odontogram_icdx.length > 0) {
            this.postData.odontogram_icdx.forEach(icdx => {
              if (ns) return;
              let odonIcdx = icdx.find(v => v.nonSpesialis == 1);
              if (odonIcdx) {
                ns = true;
                this.tacc.diagnosa = `${odonIcdx.kode} - ${odonIcdx.description}`;
              } else ns = false;
            });
            if (!ns && this.postData.kode_penyakit_primary) {
              this.tacc.nonSpesialis = this.postData.kode_penyakit_primary.nonSpesialis;
              this.tacc.diagnosa = `${this.postData.kode_penyakit_primary.kode} - ${this.postData.kode_penyakit_primary.description}`;
            } else this.tacc.nonSpesialis = ns;
          } else {
            if (this.postData.kode_penyakit_primary) {
              this.tacc.nonSpesialis = this.postData.kode_penyakit_primary.nonSpesialis;
              this.tacc.diagnosa = `${this.postData.kode_penyakit_primary.kode} - ${this.postData.kode_penyakit_primary.description}`;
            } else {
              this.$emit('icdxRujukanCheck', false);
              this.$swal({
                title: 'Harap Mengisi Diagnosa',
                html: `mohon cek kembali diagnosa di data rekam medis untuk dapat melanjutkan ke halaman berikutnya`,
                type: 'warning',
                allowOutsideClick: false
              });
              return;
            }
          }

          if (this.tacc.nonSpesialis) {
            this.$refs['__modal_tacc'].show();
            return;
          } else {
            this.updatePostData({ key: 'kd_tacc', value: null });
            this.updatePostData({ key: 'alasan_tacc', value: null });
          }
        }

        this.showRujukan('rujukan');
      },
      async showRujukan(type) {
        if (type == 'tacc') {
          this.tacc = this.defaultTACC();
          this.$refs['__modal_tacc'].hide();
        }

        if (!this.rujukan.is_back) {
          this.rujukan = this.defaultRujukan();
          this.table = this.defaultTable();
          await this.fetchReff();
        }
        
        await this.$refs["__modal_rujukan"].show();
        this.$root.$emit('bv::toggle::collapse', this.rujukan.selected);
        this.$root.$emit('bv::toggle::collapse', this.rujukan.selectedVertical);
      },
      hideModalRujukan() {
        this.rujukan = this.defaultRujukan();
        this.$refs["__modal_rujukan"].hide();
      },
      showModalConfirm() {
        this.$refs["__modal_rujukan_confirm"].hide();
        this.$refs["__modal_rujukan_print"].show();
      },
      async hideModalConfirm() {
        this.$refs["__modal_rujukan_confirm"].hide();
        await this.$refs["__modal_rujukan"].show();
        this.$root.$emit('bv::toggle::collapse', this.rujukan.selected);
        this.$root.$emit('bv::toggle::collapse', this.rujukan.selectedVertical);
      },
      async hideModalPrint() {
        this.$refs["__modal_rujukan_print"].hide();
        await this.$refs["__modal_rujukan"].show();
        this.$root.$emit('bv::toggle::collapse', this.rujukan.selected);
        this.$root.$emit('bv::toggle::collapse', this.rujukan.selectedVertical);
      },
      async showPrint() {
        const { tipe_rujuk } = this.rujukan;
        if (tipe_rujuk == null || tipe_rujuk == '' || tipe_rujuk == undefined) {
          this.rujukan.error.tipe_rujuk = true;
          this.rujukan.is_tipe_rujuk = false;
          return;
        }

        this.updatePostData({
          key: 'tipe_rujuk',
          value: tipe_rujuk,
        });

        const check = this.validateRekamMedis()
        if (check != 'success') {
          this.$refs["__modal_rujukan_print"].hide();
          return this.handleError(`Silakan lengkapi data Anda! <br> ${check}`);
        }

        // simpan rekam medis
        await this.saveRekamMedis(true);

        if (this.postData.noKunjungan) {
          const res = await this.$axios.get(`bpjs/surat-rujuk`, {
            params: {
              klinik_id: this.getKlinikId,
              dokter_id: this.postData.dokter_id,
              noKunjungan: this.postData.noKunjungan,
              tipe_pdf: tipe_rujuk,
              transklinik_id: this.postData.transklinik_id,
              kdKhusus: this.postData.kdKhusus,
              kdSpesialis: this.postData.kdSpesialis,
              kdSubSpesialis: this.postData.kdSubSpesialis,
              kdSarana: this.postData.kdSarana,
            }
          });
          const { status, data, message } = res.data;

          if (status && message == 'success') {
            window.open(data.link, '_blank');
            this.rujukan.error.tipe_rujuk = false;
            this.rujukan.is_back = false;
            this.rujukan.is_tipe_rujuk = true;
            this.$refs["__modal_rujukan_print"].hide();
          } else {
            return this.handleError('Gagal mencetak surat rujukan.');
          }
        } else {
          if (this.error_sync_msg) {
            this.$swal({
              title: "Oops...",
              html: `Gagal mencetak surat rujukan.${this.error_sync_msg}`,
              type: "error",
              allowOutsideClick: false
            });
            return;
          }
          
          return this.handleError('Gagal mencetak surat rujukan.');
        }
      },
      defaultRujukan() {
        return {
          selected: null,
          tanggal_rujuk: moment().toDate(),
          selectedVertical: null,
          selectedFaskes: null,
          tipe_rujuk: null,
          is_tipe_rujuk: false,
          is_back: false,
          khusus: {
            optKhusus: [],
            optSubSpesialis: [],
            selectedKhusus: null,
            selectedSubSpesialis: null,
            show_subspesialis: false,
            note_khusus: null,
          },
          spesialis: {
            optSpesialis: [],
            optSubSpesialis: [],
            optSarana: [],
            selectedSpesialis: null,
            selectedSubSpesialis: null,
            selectedSarana: null,
            checkboxSarana: null,
            show_sarana: false,
          },
          detail: {
            faskes: null,
            spesialis: null,
            subspesialis: null,
            catatan: null,
          },
          error: {
            tanggal_rujuk: false,
            vertical: false,
            reffKhusus: false,
            reffKhususSubSpesialis: false,
            note_khusus: false,
            note_khusus_msg: null,
            reffSpesialis: false,
            reffSubSpesialis: false,
            reffSarana: false,
            tipe_rujuk: false,
          },
          nonSpesialis: null,
          kd_tacc: null,
          alasan_tacc: null,
          is_tacc: false,
          modal_title: 'Pencarian Fasilitas Kesehatan Rujukan',
        }
      },
      defaultTable() {
        return {
          search: null,
          listFaskes: [],
          currentPage: 1,
          perPage: 10,
          totalEntries: 0,
          pageOptions: [5, 10, 25, 50, 100],
          fromX: 0,
          toX: 0,
        }
      },
      setTglRujukan(date) {
        return moment(date).format('DD-MM-YYYY');
      },
      validateRekamMedis() {
        let msg = [];
        if (!this.postData.anamnesa_text) msg.push('Anamnesa');        
        if (!this.saving_params.is_poli_gigi && !this.postData.kode_penyakit) msg.push('Diagnosis');
        if (this.saving_params.is_bpjs) {
          if (this.postData.kdSadar == undefined || this.postData.kdSadar == null || this.postData.kdSadar == '') msg.push('Pemeriksaan Fisik');
          if (this.postData.kdStatusPulang == undefined || this.postData.kdStatusPulang == null || this.postData.kdStatusPulang == '') msg.push('Status Pulang');
          
          const strippedContent = this.postData.anamnesa_text ? this.postData.anamnesa_text.replace(/<[^>]*>?/gm, '').trim() : "";
          if(strippedContent.length < 10) msg.push('Anamnesa');
        }

        if (msg.length > 0) return msg.join(', ');
        else return 'success';
      },
      async fetchFaskesKhusus() {
        const { tanggal_rujuk, khusus } = this.rujukan;

        this.updatePostData({
          key: 'kdSpesialis',
          value: null,
        });
        this.updatePostData({
          key: 'kdSubSpesialis',
          value: null,
        });
        this.updatePostData({
          key: 'kdSarana',
          value: null,
        });

        let kdKhusus = null,
          tglRujuk = null,
          subspesialis = null,
          labelKhusus = null,
          labelSubSpesialis = null;
        if (!khusus.selectedKhusus) {
          this.rujukan.error.reffKhusus = true;
        } else {
          this.rujukan.error.reffKhusus = false;
          kdKhusus = khusus.selectedKhusus.value;
          labelKhusus = khusus.selectedKhusus.label;
          this.updatePostData({
            key: 'kdKhusus',
            value: khusus.selectedKhusus.value,
          });
        }
        if (tanggal_rujuk == null || tanggal_rujuk == '' || tanggal_rujuk == undefined) {
          this.rujukan.error.tanggal_rujuk = true;
        } else {
          this.rujukan.error.tanggal_rujuk = false;
          tglRujuk = moment(tanggal_rujuk).format('DD-MM-YYYY')
          this.updatePostData({
            key: 'tanggal_rujuk',
            value: tglRujuk,
          });
        }
        if (['THA','HEM'].includes(kdKhusus)) {
          if (!khusus.selectedSubSpesialis) {
            this.rujukan.error.reffKhususSubSpesialis = true;
            return;
          } else {
            this.rujukan.error.reffKhususSubSpesialis = false;
            subspesialis = khusus.selectedSubSpesialis.value;
            labelSubSpesialis = khusus.selectedSubSpesialis.label;
            this.updatePostData({
              key: 'kdSubSpesialis',
              value: subspesialis,
            });
            this.updatePostData({
              key: 'kdKhususSubSpesialis',
              value: subspesialis,
            });
          }
        }
        if (khusus.note_khusus == null || khusus.note_khusus == '' || khusus.note_khusus == undefined) {
          this.rujukan.error.note_khusus = true;
          this.rujukan.error.note_khusus_msg = 'Wajib diisi';
        } else {
          if (khusus.note_khusus.length < 20) {
            this.rujukan.error.note_khusus = true;
            this.rujukan.error.note_khusus_msg = 'Alasan minimal 20 karakter';
          } else {
            this.rujukan.error.note_khusus = false;
          }
        }

        if (
          this.rujukan.error.vertical
          || this.rujukan.error.reffKhusus
          || this.rujukan.error.tanggal_rujuk
          || this.rujukan.error.note_khusus
        ) return;

        this.updatePostData({
          key: 'note_khusus',
          value: khusus.note_khusus,
        });

        this.rujukan.detail = {
          ...this.rujukan.detail,
          spesialis: labelKhusus,
          subspesialis: labelSubSpesialis,
          catatan: khusus.note_khusus,
        }

        const res = await this.$axios.get(`bpjs/faskes`, {
            params: {
              klinik_id: this.getKlinikId,
              kdKhusus: kdKhusus,
              noKartu: this.bpjs_noka,
              tglRujuk: tglRujuk,
              subspesialis: subspesialis,
            }
          }
        );
        const { metaData, response } = res.data;

        if (metaData.code == 200) {
          const list = response.list.map((item, index) => ({
            no: index+1,
            kdppk: item.kdppk,
            faskes: item.nmppk,
            kantor_cabang: item.nmkc,
            alamat: item.alamatPpk,
            telp: item.telpPpk,
            jarak: `${(item.distance/1000).toFixed(2)} KM`,
            total_rujukan: item.jmlRujuk,
            kapasitas: item.kapasitas,
            percentage: item.persentase,
            jadwal: item.jadwal,
            kelas: item.kelas,
          }));
          
          this.table = {
            ...this.table,
            listFaskes: list,
            totalEntries: list.length,
            fromX: 1,
            toX: list.length < this.table.perPage ? list.length : this.table.perPage,
          }
        }
      },
      async fetchFaskesSpesialis() {
        const { tanggal_rujuk, spesialis } = this.rujukan;
        
        this.updatePostData({
          key: 'kdKhusus',
          value: null,
        });
        this.updatePostData({
          key: 'kdKhususSubSpesialis',
          value: null,
        });
        this.updatePostData({
          key: 'note_khusus',
          value: null,
        });

        let tglRujuk = null;
        if (tanggal_rujuk == null || tanggal_rujuk == '' || tanggal_rujuk == undefined) {
          this.rujukan.error.tanggal_rujuk = true;
        } else {
          this.rujukan.error.tanggal_rujuk = false;
          tglRujuk = moment(tanggal_rujuk).format('DD-MM-YYYY')
          this.updatePostData({
            key: 'tanggal_rujuk',
            value: tglRujuk,
          });
        }

        let kdSpesialis = null;
        let kdSubSpesialis = null;
        let labelSubSpesialis = null;
        if (!spesialis.selectedSpesialis) {
          this.rujukan.error.reffSpesialis = true;
        } else {
          this.rujukan.error.reffSpesialis = false;
          if (!spesialis.selectedSubSpesialis) {
            this.rujukan.error.reffSubSpesialis = true;
          } else {
            this.rujukan.error.reffSubSpesialis = false;
            kdSubSpesialis = spesialis.selectedSubSpesialis.value || null;
            labelSubSpesialis = spesialis.selectedSubSpesialis.label || null;
            this.updatePostData({
              key: 'kdSubSpesialis',
              value: kdSubSpesialis,
            });
          }
          kdSpesialis = spesialis.selectedSpesialis.value || null;
          this.updatePostData({
            key: 'kdSpesialis',
            value: kdSpesialis,
          });
          this.updatePostData({
            key: 'kdKhusus',
            value: null,
          });
        }

        let kdSarana = null;
        if (spesialis.checkboxSarana == 'accepted') {
          if (!spesialis.selectedSarana) {
            this.rujukan.error.reffSarana = true;
          } else {
            this.rujukan.error.reffSarana = false;
            kdSarana = spesialis.selectedSarana.value || null;
            this.updatePostData({
              key: 'kdSarana',
              value: kdSarana,
            });
          }
        } else {
          this.rujukan.error.reffSarana = false;
        }

        if (
          this.rujukan.error.vertical
          || this.rujukan.error.reffSpesialis
          || this.rujukan.error.reffSubSpesialis
          || this.rujukan.error.tanggal_rujuk
          || this.rujukan.error.reffSarana
        ) return;

        this.rujukan.detail = {
          ...this.rujukan.detail,
          spesialis: null,
          subspesialis: labelSubSpesialis,
          catatan: null,
        }

        const res = await this.$axios.get(`bpjs/faskes/rujukan-sub-spesialis`, {
            params: {
              klinik_id: this.getKlinikId,
              kdSubSpesialis: kdSubSpesialis,
              kdSarana: kdSarana || 0,
              tglRujuk: tglRujuk,
            }
          }
        );
        const { metaData, response } = res.data;

        if (metaData.code == 200) {
          const list = response.list.map((item, index) => ({
            no: index+1,
            kdppk: item.kdppk,
            faskes: item.nmppk,
            kantor_cabang: item.nmkc,
            alamat: item.alamatPpk,
            telp: item.telpPpk,
            jarak: `${(item.distance/1000).toFixed(2)} KM`,
            total_rujukan: item.jmlRujuk,
            kapasitas: item.kapasitas,
            percentage: item.persentase,
            jadwal: item.jadwal,
            kelas: item.kelas,
          }));
          
          this.table = {
            ...this.table,
            listFaskes: list,
            totalEntries: list.length,
            fromX: 1,
            toX: list.length < this.table.perPage ? list.length : this.table.perPage,
          }
        }
      },
      checkAlasan() {
        let check = this.rujukan.khusus.note_khusus;
        if (check == '' || check == null || check == undefined) {
          this.rujukan.error.note_khusus = true;
          this.rujukan.error.note_khusus_msg = 'Wajib diisi';
        } else {
          if (check.length < 20) {
            this.rujukan.error.note_khusus = true;
            this.rujukan.error.note_khusus_msg = 'Alasan minimal 20 karakter';
          } else {
            this.rujukan.error.note_khusus = false;
          }
        }
      },
      hideModalTACC() {
        this.tacc = this.defaultTACC();
        this.$refs['__modal_tacc'].hide();
      },
      showModalTACC() {
        if (!this.tacc.selected) return;
        
        if (this.tacc.selected == 'dengan_tacc') {
          if (this.checkValueData(this.tacc.faktor)) {
            this.tacc.error_faktor = false;

          if (this.tacc.faktor.value != '3' && !this.checkValueData(this.tacc.alasan)) this.tacc.error_alasan = true;
          else this.tacc.error_alasan = false;
          } else this.tacc.error_faktor = true;

          if (this.tacc.error_faktor || this.tacc.error_alasan) return;
        }

        this.showRujukan('tacc')
      },
      async setSelectedTACC(event) {
        this.tacc.selected = event.target.id;
        if (this.tacc.selected == 'tanpa_tacc') {
          this.tacc_show.faktor = null;
          this.tacc_show.alasan = null;
          this.updatePostData({ key: 'kd_tacc', value: '-1' });
          this.updatePostData({ key: 'alasan_tacc', value: null });
        }
        if (this.tacc.selected == 'dengan_tacc' && this.tacc.option_faktor.length < 1) this.tacc.option_faktor = await this.fetchFaktorRujukan(this.getKlinikId);
      },
      setTaccValue($event, type) {
        const t = type == 'alasan_tacc' ? 'alasan' : 'faktor';

        let value = null;
        if ($event) {
          value = typeof $event == 'object' ? $event.value : $event;
          this.tacc[`error_${t}`] = this.tacc[`error_alasan`] = false;
          
          if (t == 'faktor') {
            let option = $event.optAlasan ? $event.optAlasan : [];
            if (value == '3') {
              this.tacc_show.alasan = this.tacc.diagnosa;
              this.updatePostData({ key: 'alasan_tacc', value: this.tacc.diagnosa });
            }
            this.tacc.alasan = null;
            this.tacc.option_alasan = option;
          }
        } else {
          this.tacc[`error_${t}`] = true;
          this.tacc.alasan = null;
        }

        this.tacc_show[t] = t == 'faktor' ? $event.label : value;
        this.updatePostData({ key: type, value: value });
      },
      defaultTACC() {
        return {
          selected: null,
          nonSpesialis: null,
          diagnosa: null,
          faktor: null,
          alasan: null,
          error_faktor: null,
          option_faktor: [],
          error_alasan: null,
          option_alasan: [],
        }
      },
    },
    watch: {
      selectedRadio: function (newVal) {
        // 1 = pilih tanggal 
        if (newVal.value === 1) {        
          this.updateSavingParams({
            key: 'is_next_konsul',
            value: true
          });

          this.tgl_next_konsultasi = false;

          this.updateSavingParams({
            key: 'tgl_next_konsultasi',
            value: this.tgl_next_konsultasi
          });

          //cek toggle auto on
          if (this.addons && (this.addons[0].sisa !== 0 || this.addons[1].sisa !== 0)) {
            this.pengingatWAvalue = true;
          }

          if (this.pengingatWAvalue == false) {
            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });

          } else if (this.pengingatWAvalue == true) {            
            if(this.selectedPengingatWA == null) {
               this.updateSavingParams({
                key: 'is_reminder',
                value: false
              });
            } else {
              this.updatePostData({
                key: 'tipe_pesan',
                value: this.selectedPengingatWA
              });

              this.updateSavingParams({
                key: 'is_reminder',
                value: true
              });
            }

            this.updatePostData({
              key: 'pesan_konsultasi',
              value: this.pasienNomor
            });           
          }
        } else {
          if (this.addons && (this.addons[0].sisa !== 0 || this.addons[1].sisa !== 0)) {
            this.pengingatWAvalue = true;
          }
          
          //tidak perlu konsul lanjutan
          if (newVal.value == 99) {
            this.pengingatvalue = false;
            this.pengingatWAvalue = false;

            this.updatePostData({
              key: 'pesan_konsultasi',
              value: null
            });

            this.updatePostData({
              key: 'tipe_pesan',
              value: null
            });

            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });

            this.updateSavingParams({
              key: 'is_next_konsul',
              value: true
            });
          } else if (this.pengingatWAvalue == false) {
            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });
          } else if (this.pengingatWAvalue == true) {            
            if(this.selectedPengingatWA == null){
               this.updateSavingParams({
                key: 'is_reminder',
                value: false
              });
            } else {
              this.updatePostData({
                key: 'tipe_pesan',
                value: this.selectedPengingatWA
              });

              this.updateSavingParams({
                key: 'is_reminder',
                value: true
              });
            }

            this.updatePostData({
                key: 'pesan_konsultasi',
                value: this.pasienNomor
            });           
          } 
        }
        this.validateNomor(this.pasienNomor); 
      },    
      pengingatWAvalue(newVal) {
        this.pengingatWAvalue = newVal

        //loss artinya tidak memilih 
        if (newVal === false) {

          this.updateSavingParams({
            key: 'is_number',
            value: true
          });

          this.updateSavingParams({
            key: 'is_reminder',
            value: true
          });

          this.updatePostData({
            key: 'pesan_konsultasi',
            value: null
          });

          this.updatePostData({
            key: 'tipe_pesan',
            value: null
          });
        }
        // true artinya toggle on
        else {
          //belum milih sama sekali reminder
          if (this.selectedPengingatWA == null) {

            this.updateSavingParams({
              key: 'is_reminder',
              value: false
            });
          } else {
            //memilih antar whatsapp / sms

            this.updatePostData({
              key: 'pesan_konsultasi',
              value: this.pasienNomor
            });

            this.updatePostData({
              key: 'tipe_pesan',
              value: this.selectedPengingatWA
            });
          }
        }
        this.validateNomor(this.pasienNomor)
      },
      pengingatvalue(newVal) {
        if (newVal === false) {
          this.updateSavingParams({
            key: 'is_email',
            value: true
          });
          this.updateSavingParams({
            key: 'is_email_format',
            value: true
          });
        } else {
          this.validateEmail(this.pasienEmail)
          this.updatePostData({
            key: 'email_konsultasi',
            value: this.pasienEmail
          });
        }
      },
      "table.currentPage": function (data) {
        this.table.fromX = data * this.table.perPage - this.table.perPage + 1;
        let lastPage = data * this.table.perPage;
        let total = this.table.totalEntries;
        if (total < lastPage) {
          this.table.toX = lastPage - this.table.perPage + (total % this.table.perPage);
        } else {
          this.table.toX = lastPage;
        }
      },
      "rujukan.tipe_rujuk": function () {
        if (this.rujukan.tipe_rujuk) {
          this.rujukan.error.tipe_rujuk = false;
        } else {
          this.rujukan.error.tipe_rujuk = true;
        }
      },
      "rujukan.khusus.selectedKhusus": function () {
        const kdKhusus = this.rujukan.khusus.selectedKhusus ? this.rujukan.khusus.selectedKhusus.value : null;
        if (['THA','HEM'].includes(kdKhusus)) {
          this.rujukan.khusus.show_subspesialis = true;
        } else {
          this.rujukan.khusus.show_subspesialis = false;
          this.rujukan.khusus.selectedSubSpesialis = null;
        }

        if (this.rujukan.khusus.selectedKhusus) {
          this.rujukan.error.reffKhusus = false;
        } else {
          this.rujukan.error.reffKhusus = true;
        }
      },
      "rujukan.khusus.selectedSubSpesialis": function () {
        if (this.rujukan.khusus.selectedSubSpesialis) {
          this.rujukan.error.reffKhususSubSpesialis = false;
        } else {
          this.rujukan.error.reffKhususSubSpesialis = true;
        }
      },
      "rujukan.spesialis.checkboxSarana": function (newVal) {
        if (newVal == 'accepted') {
          this.rujukan.spesialis.show_sarana = true;
        } else {
          this.rujukan.error.reffSarana = false;
          this.rujukan.spesialis.show_sarana = false;
        }
      },
      "rujukan.spesialis.selectedSpesialis": async function () {
        const spesialis = this.rujukan.spesialis.selectedSpesialis;
        if (this.rujukan.spesialis.selectedSpesialis) {
          this.rujukan.error.reffSpesialis = false;
        } else {
          this.rujukan.error.reffSpesialis = true;
        }
        if (spesialis && spesialis.value) {
          this.rujukan.spesialis.selectedSubSpesialis = null;
          this.rujukan.error.reffSubSpesialis = false;
          await this.fetchReffSubSpesialis(spesialis.value);
        }
      },
      "rujukan.spesialis.selectedSubSpesialis": function () {        
        if (this.rujukan.spesialis.selectedSubSpesialis) {
          this.rujukan.error.reffSubSpesialis = false;
        } else {
          this.rujukan.error.reffSubSpesialis = true;
        }
      },
      "rujukan.spesialis.selectedSarana": function () {        
        if (this.rujukan.spesialis.selectedSarana && this.rujukan.spesialis.checkboxSarana == 'accepted') {
          this.rujukan.error.reffSarana = false;
        } else {
          this.rujukan.error.reffSarana = true;
        }
      },
    }
  };
</script>

<style>
  .custom_select {
    background-color: #ffffff;
  }
  .custom_select .vs__dropdown-toggle .vs__selected-options .vs__search::placeholder {
    color:#cfcfcf !important;
    font-size: 14px !important;
  }
  .modal-backdrop {
    opacity: 0.5 !important;
  }
  .kategori_khusus .vs__dropdown-menu {
    max-height: 75px;
  }
  .kategori_khusus_subspesialis .vs__dropdown-menu {
    max-height: 125px;
  }
  .spesialis_subspesialis .vs__dropdown-menu {
    max-height: 100px;
  }
  .table_faskes .table {
    font-size: 0.85em !important;
  }
  .table_faskes .head_custom {
    text-align: center;
    background-color: #ffffff !important;
    vertical-align: middle !important;
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index: 1;
    box-shadow: inset 0 2px 0 #3c44b1, inset 0 -2px 0 #3c44b1;
  }
  .table_faskes .head_width {
    min-width: 175px;
  }
  .modal_rujukan .modal-header {
    background-color: #ffffff;
  }
  .card-rujukan .custom-radio .custom-control-input:disabled ~ .custom-control-label {
    color: #3b3e66;
  }
  .__form-tacc .vs__dropdown-toggle .vs__selected-options .vs__search::placeholder {
    color:#cfcfcf !important;
    font-size: 14px !important;
  }
  .__form-tacc .vs__dropdown-toggle {
    height: 42px !important;
  }
  .__form-tacc .vs__dropdown-menu {
    position: relative;
  }
  .mb-faktor {
    margin-bottom: 7rem;
  }
  .btn-tacc-agree {
    color: #fff;
    background-color: #1791EE;
    border-color: #1791EE;
    box-shadow: 0 0.25rem 0.55rem rgba(23, 145, 238, 0.35);
  }
  .btn-tacc-agree:hover {
    color: #fff;
  }
</style>

<style scoped>
  .select-red option span {
    color: red !important;
  }
  .select-red option .text-blue {
    color: blue !important
  }
  .card {
    background-color: #f8f9ff;
  }
  .card-rujukan {
    box-shadow: none;
  }
  .card-rujukan .card-body {
    background-color: #ffffff;
  }
  .btn_faskes {
    cursor: pointer;
  }
</style>
